/* app/js/src/components/user-branding/user-branding-dashboard/user-branding-dashboard.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  width: 100%;
  height: 100%;
  display: block;
}
.container {
  width: 100%;
  height: 100%;
  background-color: white;
}
.container .header {
  padding: 1vw;
}
.container .header div {
  font-size: xxx-large;
}
.container .dashboard-table {
  width: 97%;
  margin: 0 auto;
  text-align: center;
  color: #232f3a;
}
.container .dashboard-table .default-setting {
  font-weight: bolder;
}
.container .dashboard-table tr {
  cursor: pointer;
}
.container .dashboard-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.container .dashboard-table tbody tr:hover {
  background-color: #e7dfdf;
}
.container .dashboard-table th {
  border-bottom: 1px solid #232f3a;
}
.container .dashboard-table th,
.container .dashboard-table td {
  height: 2vw;
  text-align: left;
  padding-left: 1vw;
}
.container .dashboard-table th.actions,
.container .dashboard-table td.actions {
  width: 5vw;
}
.container .dashboard-table th > span.Low,
.container .dashboard-table td > span.Low {
  color: #4472c1;
}
.container .dashboard-table th > span.Medium,
.container .dashboard-table td > span.Medium {
  color: #f5d7ac;
}
.container .dashboard-table th > span.High,
.container .dashboard-table td > span.High {
  color: #c49c9e;
}
.container .dashboard-table th > a,
.container .dashboard-table td > a {
  color: #40c4ff;
  text-decoration: none;
}
.container .dashboard-table th > a:hover,
.container .dashboard-table td > a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=user-branding-dashboard.component.css.map */
